import * as io from "io-ts";
import { nullable } from "diagnostics-lib/io";
import createGlobalState from "@ui/lib/createGlobalState";

export const useReparabilityMatrixPeriod = createGlobalState({
  storage: "session",
  key: "ReparabilityMatrixPeriod",
  type: nullable(io.number),
  defaultValue: null,
  scoped: false,
});
